export default __webpack_public_path__ + "static/media/Mockup-Cel-1.4bb1ad4c.png";